import React, { useEffect, useState } from "react";
import { GroupWrapper } from "../HOC";
import {
  FeedProfile,
  FeedThought,
  FeedConnections,
  FeedGroup,
  FeedBusinesses,
  FeedNeighbors,
  MyGroups,
  MyExplore,
} from "../components";
import { useGroup } from "../context/GroupContext";
import GroupView from "../components/GroupView";
import { usePost } from "../context/PostContext";

const Feed = () => {
  const [community, setCommunity] = useState("");
  const [group, setGroup] = useState("");
  const { openedGroup } = useGroup();
  const { posts, setGroupData } = usePost();

  useEffect(() => {
    if(openedGroup) setGroup("");
  }, [openedGroup])
  
  useEffect(() => {
    if (community === '') setGroupData(null)
  }, [community, setGroupData])

  return (
    <GroupWrapper
      setCommunity={setCommunity}
      community={community}
      setGroup={setGroup}
    >
      <div className="w-[52%] pb-10">
        {community === "connections" && <FeedConnections />}
        {(community === "") && (
          <>
            <FeedThought />
            {posts.length > 0 && posts.map((post) => {
              return (<FeedProfile key={post?.id} data={post} />)
            })}
            {/* <FeedProfile three />
                <FeedProfile video />
                <FeedProfile three video /> */}
          </>
        )}
        {community === "groups" && (
          <>
            <FeedGroup group={group} setGroup={setGroup} />
            {(group === "") ? (
              <>
                {openedGroup && <GroupView data={openedGroup} />}
                <FeedThought />
                { posts.length > 0 && posts.map((post) => {
                  return (<FeedProfile key={post?.id} data={post} />)
                })}
              </>
            ) : group === "mygroups" ? (
              <MyGroups />
            ) : (
              group === "explore" && <MyExplore />
            )}
          </>
        )}
        {community === "businesses" && <FeedBusinesses />}
        {community === "neighbors" && <FeedNeighbors />}
      </div>
    </GroupWrapper>
  );
};

export default Feed;
